// Page: Company Profiles
// URL: https://local.ratemyplacement.co.uk/company-profile/69/ey/jobs
// Status: In Use
// Comments:
// Required Core Stylesheet

import './core-pages/media-gallery';
import './core-pages/splide';

function setupShowMoreLess() {
  const showContentHeight = 300; // How tall the content area is for copy.
  const moreText = 'Show more';
  const lessText = 'Show less';

  const $companyAboutSectionText = document.querySelector('.js-company-text');

  if ($companyAboutSectionText === null) {
    return false;
  }

  const contentHeight = $companyAboutSectionText.offsetHeight;

  if (contentHeight > showContentHeight) {
    $companyAboutSectionText.style.height = `${showContentHeight}px`;
    $companyAboutSectionText.classList.add('is-less');

    const showMoreHTML = document.createElement('a');
    showMoreHTML.innerHTML = moreText;
    showMoreHTML.classList.add('morelink');
    showMoreHTML.classList.add('js-morelink');

    document.querySelector('.company-about .section').insertBefore(showMoreHTML, $companyAboutSectionText.nextSibling);
  }

  const $moreLink = document.querySelector('.js-morelink');

  if ($moreLink !== null) {
    $moreLink.addEventListener('click', (e) => {
      const $currentTarget = e.currentTarget;

      if ($currentTarget.classList.contains('is-less')) {
        $currentTarget.classList.remove('is-less');
        $currentTarget.innerHTML = moreText;

        $companyAboutSectionText.classList.add('is-less');
        $companyAboutSectionText.style.height = `${showContentHeight}px`;
      } else {
        $currentTarget.classList.add('is-less');
        $currentTarget.innerHTML = lessText;

        $companyAboutSectionText.classList.remove('is-less');
        $companyAboutSectionText.style.height = 'auto';
      }
      return false;
    });
  }

  return true;
}

if (document.querySelector('.js-company-profile') !== null) {
  setupShowMoreLess();
}
